import '../css/ContactSection.css';

function ContactSection() {
    return (
        <section id="contact" className="contact-section">
            <div>
                <p className="section-name">Contact</p>
                <p className="contact-note">Open to requests or a conversation.</p>
                <a className="contact-email" href="mailto:adityapatel1204+wrk@gmail.com">
                    adityapatel1204+wrk@gmail.com
                </a>
                <div className="contact-links">
                    <a href="https://github.com/adityapatel-sudo" target="_blank" rel="noreferrer">GitHub</a>
                    <a href="https://www.linkedin.com/in/aditpate/" target="_blank" rel="noreferrer">LinkedIn</a>
                    <a href="https://x.com/aditpate" target="_blank" rel="noreferrer">X</a>
                </div>
            </div>
            <p>© {new Date().getFullYear()} Aditya Patel</p>
        </section>
    );
}

export default ContactSection;
